module.exports = __webpack_public_path__ + "img/cerca-auto-white.1c1da917.svg";